<template>
  <div class="pkt-overlay" @click.self="$emit('close')">
    <div class="card pkt-card" role="dialog" :aria-label="title">
      <div class="card-head">
        <h3>{{ title }}</h3>
        <button class="pkt-x" aria-label="Fechar" @click="$emit('close')">
          ✕
        </button>
      </div>

      <p v-if="subtitle" class="pkt-sub">{{ subtitle }}</p>

      <div class="pkt-grid">
        <div class="field">
          <label class="label">Data</label>
          <select
            v-model="date"
            class="select"
            :disabled="!dateOptions.length"
            @change="time = ''"
          >
            <option value="" disabled>{{ placeholder }}</option>
            <option v-for="d in dateOptions" :key="d" :value="d">
              {{ fmtDate(d) }}
            </option>
          </select>
        </div>
        <div class="field">
          <label class="label">Horário</label>
          <select v-model="time" class="select" :disabled="!date">
            <option value="" disabled>Selecione…</option>
            <option v-for="t in timeOptions" :key="t" :value="t">
              {{ t }}
            </option>
          </select>
        </div>
      </div>

      <div class="pkt-actions">
        <button class="btn btn--outline btn--sm" @click="$emit('close')">
          Cancelar
        </button>
        <button
          class="btn btn--primary btn--sm"
          :disabled="!date || !time"
          @click="confirm"
        >
          {{ cta }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Seletor de novo horário a partir dos slots DISPONÍVEIS reais do médico
// (mesma fonte do agendamento). Usado por Sugerir horário e Reagendar —
// substitui o horário fixo de protótipo que sugeria datas no passado.
import { ClinicAgenda } from "@/services/clinica";

export default {
  name: "ClinicPickTime",
  props: {
    doctorId: { type: String, required: true },
    title: { type: String, required: true },
    cta: { type: String, required: true },
    subtitle: { type: String, default: "" }
  },
  data() {
    return {
      slotDays: [],
      loading: true,
      date: "",
      time: ""
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await ClinicAgenda.doctorSlots(this.doctorId);
        this.slotDays = data || [];
      } catch (e) {
        this.$toast.error(
          "Não foi possível carregar os horários do profissional de saúde"
        );
      } finally {
        this.loading = false;
      }
    },
    isFuture(date, time) {
      return new Date(`${date}T${time}:00`) > new Date();
    },
    fmtDate(iso) {
      const [y, m, d] = iso.split("-");
      return `${d}/${m}/${y}`;
    },
    confirm() {
      this.$emit("pick", `${this.date}T${this.time}:00`);
    }
  },
  computed: {
    // agrupa por slot_date — pode haver mais de um Slot no mesmo dia (ex.
    // duplicado por reenvio de "Criar agenda"); sem isso o .find() só via o
    // primeiro bloco e escondia horários do resto do dia.
    groupedDays() {
      return this.slotDays.reduce((acc, day) => {
        const times = (day.slots || []).filter(t =>
          this.isFuture(day.slot_date, t)
        );
        if (times.length) {
          acc[day.slot_date] = [
            ...new Set([...(acc[day.slot_date] || []), ...times])
          ];
        }
        return acc;
      }, {});
    },
    dateOptions() {
      return Object.keys(this.groupedDays);
    },
    timeOptions() {
      return this.groupedDays[this.date] || [];
    },
    placeholder() {
      if (this.loading) return "Carregando horários…";
      if (!this.dateOptions.length) return "Sem horários disponíveis";
      return "Selecione…";
    }
  }
};
</script>

<style lang="scss" scoped>
.pkt-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-5);
}
.pkt-card {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}
.pkt-x {
  border: none;
  background: none;
  color: var(--color-gray-400);
  font-size: var(--font-size-md);
  cursor: pointer;
  &:hover {
    color: var(--color-gray-700);
  }
}
.pkt-sub {
  font-size: var(--font-size-sm);
  color: var(--color-gray-500);
  margin: 0;
}
.pkt-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-4);
}
.pkt-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
}
</style>
